var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectWithMobileConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 60,
    viewBox: "0 0 38 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7 60H32.3C35.4469 60 38 57.4805 38 54.375V5.625C38 2.51953 35.4469 0 32.3 0H5.7C2.55312 0 0 2.51953 0 5.625V54.375C0 57.4805 2.55312 60 5.7 60ZM1.9 5.625C1.9 3.55781 3.60525 1.875 5.7 1.875H32.3C34.3947 1.875 36.1 3.55781 36.1 5.625V54.375C36.1 56.4422 34.3947 58.125 32.3 58.125H5.7C3.60525 58.125 1.9 56.4422 1.9 54.375V5.625ZM13.3 53.4375H24.7C25.2232 53.4375 25.65 53.0182 25.65 52.5C25.65 51.9818 25.2232 51.5625 24.7 51.5625H13.3C12.7768 51.5625 12.35 51.9818 12.35 52.5C12.35 53.0182 12.7775 53.4375 13.3 53.4375Z",
    fill: "#007E8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectWithMobileConnect);
export default __webpack_public_path__ + "static/media/connectWithMobileConnect.dfd5aed9b00a6907c71e2b47849408e4.svg";
export { ForwardRef as ReactComponent };